import { MemberStatus } from "@upsquad/shared";
import { Navigate } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { getIsAuthenticated, getIsProfileComplete } from "@/src/auth/store/auth-selectors";
import { Spinner } from "@/src/common/components/ui";
import { COMMON_ROUTES } from "@/src/common/constants/common-routes";
import { getSubdomain } from "@/src/common/lib/subdomain";
import { RootRedirect } from "@/src/common/navigations/root-redirect";
import { useAppSelector } from "@/src/common/redux/store";
import { useGetMyMembershipBySlugQuery } from "@/src/community/services/community-http.service";
import { ONBOARDING_ROUTES } from "@/src/onboarding/constants/onboarding-routes";
import { AppLayout } from "./app-layout";

export function AppRouteLayout() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const isProfileComplete = useAppSelector(getIsProfileComplete);
	const subdomain = getSubdomain();

	const shouldCheckMembership = !!subdomain && isAuthenticated && isProfileComplete;
	const { data, error, isLoading } = useGetMyMembershipBySlugQuery(subdomain ?? "", { skip: !shouldCheckMembership });

	if (!isAuthenticated) {
		return <Navigate to={AUTH_ROUTES.AUTH} replace />;
	}

	if (!isProfileComplete) {
		return <Navigate to={ONBOARDING_ROUTES.PROFILE} replace />;
	}

	if (!subdomain) {
		return <RootRedirect />;
	}

	if (isLoading) {
		return (
			<div className="flex min-h-screen items-center justify-center">
				<Spinner size="lg" />
			</div>
		);
	}

	if (error) {
		return <Navigate to={COMMON_ROUTES.COMMUNITY_NOT_FOUND} replace />;
	}

	if (!data || data.status === null || data.status === MemberStatus.INVITED) {
		return <Navigate to={ONBOARDING_ROUTES.JOIN_COMMUNITY} replace />;
	}

	if (data.status !== MemberStatus.APPROVED) {
		return <Navigate to={ONBOARDING_ROUTES.PENDING_JOIN_COMMUNITY} replace />;
	}

	return <AppLayout />;
}
